export const hasUppercase = ({ value }: { value: unknown }) => {
  return /[A-Z]/.test(value as string);
};

export const hasLowercase = ({ value }: { value: unknown }) => {
  return /[a-z]/.test(value as string);
};

export const hasNumber = ({ value }: { value: unknown }) => {
  return /\d/.test(value as string);
};

export const hasSpecialChar = ({ value }: { value: unknown }) => {
  return /[!"`'#%&,:;<>=@{}~$()*+\/\\?\[\]^|]/.test(value as string);
};
